import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
// (참고) 최신버전 오류로 구버전(6.8.4) 버전을 적용 // 구버전 swiper는 css 불러올때 min.css 통해 불러와야 함
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
import SwiperCore, { Navigation, EffectFade } from 'swiper'
import './characters.css'
import { faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function Characters() {
    // Navigation 사용시 SwiperCore를 이용하여 Navigation을 사용할 것임을 알려줘야 함
    // 추가로 작동되지 않는 기능들이 있을때도 확인하여 추가(Effect에 Fade기능이 작동하지 않아 추가함)
    SwiperCore.use([Navigation, EffectFade]);

    const swiperStyle = {
        position: 'relative',
        width: '100%',
        height: '100%'
    }

    const swiperNavigation = {
        nextEl: '.swiper-next', 
        prevEl: '.swiper-prev'
    }

    const charWrite = characterList.map(char => {
        return (
            <SwiperSlide key={char.id}>
                <div className='char_bg' style={char.style}>
                    <div className='char_info'>
                        <h2>{char.name}</h2>
                        <h5>{char.actor}</h5>
                    </div>
                </div>
            </SwiperSlide>
        )
    })

    return(
        <section className='characters'>
            <Swiper
                effect={'fade'}
                speed={1000}
                style={swiperStyle}
                navigation={swiperNavigation}
                loop={true}
            >
                {charWrite}
                <button type='button' className='swiper-prev'>
                    <FontAwesomeIcon icon={faCaretLeft} />
                    <span>Prev</span>  
                </button>
                <button type='button' className='swiper-next'>
                    <FontAwesomeIcon icon={faCaretRight} />
                    <span>Next</span>  
                </button>
            </Swiper>
        </section>
    )

}

export default Characters
const characterList = [
    {
        id: 1,
        name: 'Wanda Maximoff',
        actor: 'Elizabeth Olsen',
        style: {
            background: "url('./images/wanda.png') no-repeat center"
        }
    },
    {
        id: 2,
        name: 'Vision',
        actor: 'Paul Bettany',
        style: {
            background: "url('./images/vision.png') no-repeat center"
        }
    },
    {
        id: 3,
        name: 'Agnes',
        actor: 'Kathryn Hahn',
        style: {
            background: "url('./images/agnes.png') no-repeat center"
        }
    },
    {
        id: 4,
        name: 'Monica Rambeau',
        actor: 'Teyonah Parris',
        style: {
            background: "url('./images/monica.png') no-repeat center"
        }
    },
]